import { InstagramEmbed } from "react-social-media-embed";
import config from "../../Admin/Config.json";

export default function Influencer({ collabaration, influencerCollab }) {
  const { ShowInWebSite, content, heading, media } = influencerCollab;

  let collabCards = content?.map((item, index) => {
    return {
      img: media[index],
      url: item.title,
    };
  });

  const handleImageClick = (url) => {
    window.open(url, "_blank");
  };
  return (
    ShowInWebSite === 1 && (
      <div className="collabaration">
        <img
          src={collabaration.leafleft}
          style={{ width: "10%", position: "absolute", top: "-5px" }}
        />
        <div className="collabration-text">
          <p>
            {heading}
            <img src={collabaration.ElipseHeading} alt="heading circle" />
          </p>
        </div>
        <div className="influencer-insta-container">
          {collabCards?.map((item, index) => (
            <div
              className="influencer-div"
              style={{ display: "flex", justifyContent: "center" }}
              key={index}
              onClick={() => handleImageClick(item?.url)}
            >
              {/* <InstagramEmbed url={item.url} width={328} /> */}
              <img
                className="collab-thumbnail"
                src={config.awsMediaPath + item.img}
              />
            </div>
          ))}
        </div>
      </div>
    )
  );
}
